import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import i18next from "i18next";

import { safeLocale } from "@/utilities/i18n/safeLocale";

const ParkingCell = (props: GridRenderCellParams) => {
  const parking = props.row?.parking;
  const displayValue = props.formattedValue || "---";

  const ts = parking?.timestamp
    ? parking.timestamp instanceof Date
      ? parking.timestamp
      : new Date(parking.timestamp)
    : null;

  const formattedTs =
    ts &&
    new Intl.DateTimeFormat(safeLocale(i18next.language), {
      dateStyle: "medium",
      timeStyle: "short",
    }).format(ts);

  const title = formattedTs ? `${i18next.t("faultOverview.since")} ${formattedTs}` : "";

  return (
    <Tooltip title={title} arrow>
      <Box sx={{ overflow: "hidden", textOverflow: "ellipsis" }}>{displayValue}</Box>
    </Tooltip>
  );
};
export default ParkingCell;
